type Body = any | undefined;
type ContentType = string | undefined;

export default (body: Body, contentType: ContentType): string => {
  // If no Body has been provided
  if (!body || !contentType) {
    return "";
  }

  return `data:${contentType};base64, ${body.toString("base64")}`;
};
